import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import "../Curriculum.css";
import ExamForm from "./ExamForm";
import DeleteConfirmDialog from "../components/DeleteConfirmDialog";
import {Panel} from "primereact/panel";
import Toggle from "../components/Toogle";
import GeneralUtils from "../../../../../utils/GeneralUtils";
import {ExamService} from "../../../../../service/ExamService";
import Question from "./Question";


const Exam = (props) => {
    const {course, chapter, setChapter} = props;
    const [data, setData] = useState(chapter.examList ? chapter.examList : []);
    const [activeIndex, setActiveIndex] = useState();
    const [toggleForm, setToggleForm] = useState(false);
    const [lectureToDelete, setLectureToDelete] = useState(null);
    const service = new ExamService();

    useEffect(() => {
        setChapter(data);
    }, [data, setChapter]);

    const addExam = (exam) => {
        exam.chapter = chapter.id;
        exam.objectIndex = data.length + 1;
        service.create(exam).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                response.chapter = response.chapter?.id;
                setData([...data, response]);
                setToggleForm(!toggleForm);
            }
        });
    }

    const updateExam = (exam) => {
        exam.chapter = chapter.id;
        service.update(exam).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                setData(prev => prev.map((item) => {
                    if (item.id === response.id) {
                        return {
                            ...item,
                            ...response,
                            questionList: response.questionList ?? item.questionList ?? [],
                            questionPoolSize: response.questionPoolSize ?? item.questionPoolSize ?? (Array.isArray(item.questionList) ? item.questionList.length : item.questionPoolSize),
                        };
                    }
                    return item;
                }));
                setActiveIndex(-1);
            }
        });
    };

    const deleteExam = (id) => {
        service.delete(id).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                setData((prevData) => prevData.filter((exam)=> exam.id !== id));
            }
        });
    };


    const renderView = (options, exam, index) => {
        const toggleIcon = exam.questionList
            ? (options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up')
            : (options.collapsed ? 'pi pi-plus' : 'pi pi-minus');
        const borderColor = exam.questionList ? "" : "border-danger";
        const className = `${options.className} justify-content-start`;

        return (
            <div
                className={className + " flex flex-row align-items-center bg-white w-full gap-3 px-2 py-1 " + borderColor}>
                <div className="flex flex-row align-items-center gap-2 flex-1 min-w-0">
                    <p className="m-0" style={{minWidth: "50px", fontWeight: 600}}>Sınav {exam.objectIndex}:</p>
                    <p className="m-0 text-overflow-ellipsis overflow-hidden white-space-nowrap flex-1"
                       title={exam.title}>{exam.title}</p>
                </div>

                <div className="flex flex-row align-items-center gap-2 flex-shrink-0">
                    {(index === data.length - 1) && <Button icon="pi pi-fw pi-trash" rounded text severity="danger"
                                                            onClick={() => setLectureToDelete(exam)}/>}

                    <Button icon="pi pi-fw pi-pencil" rounded text severity="secondary"
                            onClick={() => setActiveIndex(index)}/>

                    <Button icon={toggleIcon} severity="secondary" rounded text onClick={options.onTogglerClick}
                            size="small"/>
                </div>
            </div>
        );
    };


    const renderEdit = (exam, index) => (
        <div className="pl-4 pr-4 pt-2 pb-2">
            <ExamForm
                index={index}
                data={exam}
                cancel={() => setActiveIndex(-1)}
                save={(exam) => updateExam(exam)}
            />
        </div>
    );

    const renderTitle = (options, exam, index) => (
        index !== activeIndex
            ? renderView(options, exam, index)
            : renderEdit(exam, index)
    );


    return (<div className=" ml-5">{data?.sort(GeneralUtils.compareIndex).map((exam, index) => (
            <Panel key={exam?.id ?? index} toggleable collapsed={true} headerTemplate={options => renderTitle(options, exam, index)} className="lecture-editor noshadow mb-3 mt-3">
                <div className="flex flex-column gap-2">
                    {/*{exam.description &&*/}
                    {/*    <div>*/}
                    {/*        <p><span style={{minWidth: "50px", fontWeight: "600"}}>Sınav Açıklaması: </span>{exam.description}</p>*/}
                    {/*        <Divider/>*/}
                    {/*    </div>}*/}

                    <Question course={course} chapter={chapter} exam={exam} setExam={questionList => {
                        setData(prev => prev.map((item, i) => i === index ? ({
                            ...item,
                            questionList: questionList,
                            questionPoolSize: Array.isArray(questionList) ? questionList.length : item.questionPoolSize,
                        }) : item));
                    }}/>
                </div>
            </Panel>
        ))}

            <Toggle
                label="Sınav Ekle"
                visible={toggleForm}
                onHide={() => setToggleForm(!toggleForm)}
                showCard={true}
                cardClassName="exam-form noshadow"
                containerClassName="mt-2"
            >
                <ExamForm
                    index={data.length}
                    cancel={() => setToggleForm(!toggleForm)}
                    save={(exam) => addExam(exam)}
                />
            </Toggle>


            <DeleteConfirmDialog
                itemToDelete={lectureToDelete}
                onHide={() => setLectureToDelete(null)}
                onConfirm={deleteExam}
            />
        </div>
    )
};

export default Exam;
